module.exports = __webpack_public_path__ + "sprite/buttons.json";


//////////////////
// WEBPACK FOOTER
// ./sprite/buttons.json
// module id = 121
// module chunks = 3